/* eslint-disable import/no-anonymous-default-export */
import {
  getRandomDate,
  getRandomDateBetweenRange,
  getRandomItem,
  getRandomNumber
} from '../utils.mock';

const status = [
  'emailNotified',
  'smsNotified',
  'new',
  'acknowledged',
  'closed'
];
const priority = ['low', 'medium', 'high'];
const machineIds = [78, 82, 79, 80, 81];

export default {
  data: Array.from({ length: 1000 }).map((x, i) => ({
    id: 1001 + i,
    alertSettingId: `alertSettingId-${i}`,
    Machine: {
      id: getRandomItem(machineIds),
      title: `Machine - ${i}`
    },
    machineId: getRandomItem(machineIds),
    AlertSetting: {
      id: `alertSettingId-${i}`,
      name: `Paro por mantemiento ${i + 1}`
    },
    companyId: 19,
    sentDate: getRandomDate(),
    stoppedMinutes: getRandomNumber(2, 120),
    lastStatus: getRandomItem(status),
    priority: getRandomItem(priority),
    alertSettingVersionId: getRandomNumber(100, 999),
    stopStartTime: getRandomDateBetweenRange(
      new Date('2022-07-23'),
      new Date()
    ),
    statuses: [
      {
        updatedAt: getRandomDate(),
        createdAt: getRandomDate(),
        deltaToPreviousStatusMs: getRandomNumber(100, 120),
        status: getRandomItem(status),
        addressType: 'string',
        address: 'string'
      }
    ],
    acknowledgedDate: getRandomDate(),
    createdAt: getRandomDate(),
    updatedAt: getRandomDate()
  }))
};
